import React from "react";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

function MyDateTimePicker(props) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        type="date"
        disabled={props.disabled}
        value={props.value}
        // maxDate={new Date()}
        // minDate={props.fromDate}

        ampm={false}
        style={{ backgroundColor: 'white !important' }}
        format="dd/MM/yyyy HH:mm" // Correct format for dayjs
        onChange={(event) => {
          props.action(event)
        }}
        slotProps={{
          textField: {
            sx: {
              backgroundColor: 'white', // Set background color to white
              minWidth: 'fit-content',           // Set field width to 100%
              '& .MuiInputBase-root': {
                borderRadius: '4px',    // Optional: Customize border radius
              },
            },
          }
        }}
      />
    </LocalizationProvider>
  );
}
export default MyDateTimePicker;